<template>
  <div>
    <v-card v-if="PrenotazioneChiusa()">
      <v-card-title primary-title>
          <v-btn flat icon color="success">        
                <v-icon large >insert_emoticon</v-icon>                  
          </v-btn>
        <span class="headline">FATTO!</span >
        </v-card-title>
        <v-container>
          <div name ="istr_1" class="subheading">{{labels.guida_1}}</div>
          </v-container>
    </v-card>

    <v-card v-if="!PrenotazioneChiusa() && tutticompletati()">
      <v-card-title primary-title>
          <v-btn flat icon color="warning">        
                <v-icon large >mdi-help</v-icon>                  
          </v-btn>
        <span class="headline">{{labels.instructions}}</span >
        </v-card-title>
        <v-container>
          <div name ="istr_1" class="subheading">{{labels.guida_2}} <v-btn
                      color="green"
                      class="white--text"
                      >
                        {{labels.save_and_send}}
                        <v-icon right dark>mdi-upload</v-icon>
                      </v-btn> </div>
          </v-container>
    </v-card>

    <v-card v-if="!PrenotazioneChiusa() && !tutticompletati()">  
        <v-card-title primary-title>
           <v-btn flat icon color="warning">
                              
                      <v-icon large >mdi-help</v-icon>                  
                   
                </v-btn>
            <span class="headline">{{labels.instructions}}</span >
        </v-card-title>
        <v-container>
          <div  name ="istr_2"  class="subheading">{{labels.guida_4}}
            <br>
               {{labels.guida_5}}  <v-icon large color="grey" >mdi-account</v-icon> {{labels.guida_6}}<br> 
               {{labels.guida_7}} <v-btn  success medium rounded color="success"><v-icon>mdi-check </v-icon></v-btn><br>
               {{labels.guida_8}} <v-icon large color="success" >mdi-account</v-icon>{{labels.guida_9}}<br>
               {{labels.guida_10}} 
                <v-badge overlay left color="orange" overlap>
                    <v-icon slot="badge" dark>mdi-star</v-icon>
                    <v-icon
                      large
                      color="grey"
                    >
                      mdi-account
                    </v-icon>
                </v-badge>.<br>
                 {{labels.guida_11}}  
                  <v-btn
                      color="green"
                      class="white--text"
                      >
                        {{labels.save_and_send}}
                        <v-icon right dark>mdi-upload</v-icon>
                      </v-btn>
                  
                   {{labels.guida_12}}<br>
                  <br>
                  
          </div>
        </v-container>
        </v-card >

  </div>
</template>

<script>
/* eslint-disable no-prototype-builtins */
export default {
  props: ["labels"],
  data() {
    return {

    }
  },
  watch: {

    },
  methods: {
   tutticompletati : function () {
        var retval = true
        var indice =0
        console.log("TUTTI COMPILATI?");
        for (const key in this.$store.state.reservation.visitors) {
            
            indice++;
            if (this.$store.state.reservation.visitors.hasOwnProperty(key)) {
                const element = this.$store.state.reservation.visitors[key];
                console.log('visitor compiled->',indice,element.iscompiled);
                if(element.iscompiled)
                {
                    retval = true;
                }
                else
                {
                    retval = false;
                    break;
                }
            }
        }
        retval = retval && this.$store.state.reservation.mainguest.iscompiled
        console.log("capo completato:",this.$store.state.reservation.mainguest.iscompiled);
        console.log("tutti completati:",retval);


        return retval;
      },
      PrenotazioneChiusa : function () {
        console.log('stato prenotazione:',this.$store.state.reservation.status);
        return this.$store.state.reservation.status === 'CLOSED';
      },

      
  },
  created () {

    }
};
</script>